import '../../style/index.less'
import './index.less'

// style dependencies
import '../../tabs/style'



// WEBPACK FOOTER //
// ./components/card/style/index.js